import type { HTMLChakraProps } from '@chakra-ui/react';
import { forwardRef } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

import { useConversationStyles } from '../useConversationStyles';

export type ConversationScrollButtonPositionerProps = HTMLChakraProps<'div'>;

/**
 * Positioner for the ConversationScrollButton.
 * This component positions the scroll button relative to ConversationContent
 * rather than the Conversation container, so it stays in the right place
 * even when there are other elements (like PromptBar) below the content.
 */
export const ConversationScrollButtonPositioner: React.FC<ConversationScrollButtonPositionerProps> =
  forwardRef<ConversationScrollButtonPositionerProps, 'div'>(
    ({ children, ...props }, ref) => {
      const { scrollButtonPositioner } = useConversationStyles();

      return (
        <chakra.div
          ref={ref}
          sx={scrollButtonPositioner}
          className="conversation-scroll-button-positioner"
          {...props}
        >
          {children}
        </chakra.div>
      );
    },
  );
ConversationScrollButtonPositioner.displayName =
  'ConversationScrollButtonPositioner';
